module.exports = __webpack_public_path__ + "static/media/Sketch10.480b9666.jpeg";